import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElCardModule } from '../card/card.module';
import { ElIconModule } from '../icon/icon.module';
import { ElButtonModule } from '../button/button.module';
import { ElWindowService } from './window.service';
import { ElWindowsContainerComponent } from './windows-container.component';
import { ElWindowComponent } from './window.component';
import { EL_WINDOW_CONFIG, ElWindowConfig } from './window.options';

@NgModule({
  imports: [ CommonModule, ElOverlayModule, ElCardModule, ElIconModule, ElButtonModule ],
  declarations: [
    ElWindowsContainerComponent,
    ElWindowComponent,
  ],
  entryComponents: [ElWindowsContainerComponent, ElWindowComponent],
})
export class ElWindowModule {
  static forRoot(defaultConfig?: Partial<ElWindowConfig>) {
    return <ModuleWithProviders>{
      ngModule: ElWindowModule,
      providers: [
        ElWindowService,
        { provide: EL_WINDOW_CONFIG, useValue: defaultConfig },
      ],
    };
  }

  static forChild(defaultConfig?: Partial<ElWindowConfig>) {
    return <ModuleWithProviders>{
      ngModule: ElWindowModule,
      providers: [
        ElWindowService,
        { provide: EL_WINDOW_CONFIG, useValue: defaultConfig },
      ],
    };
  }
}
